// extracted by mini-css-extract-plugin
module.exports = {"plan-item":"styles__plan-item___hGw3p","plan-list-icon":"styles__plan-list-icon___2vQgl","plan-competitor":"styles__plan-competitor___2UFOe"};